<div class="page-wrapper">
  <app-toolbar></app-toolbar>
  <main class="content"><router-outlet></router-outlet></main>
  <app-footer></app-footer>
</div>
